var map = {
	"./behance.png": 3589,
	"./crypto.png": 5282,
	"./discord.png": 605,
	"./dribbble.png": 9263,
	"./email.png": 3397,
	"./facebook.png": 1053,
	"./github.png": 5764,
	"./google business.png": 6264,
	"./google-drive.png": 2003,
	"./google-pay.png": 2281,
	"./image.png": 4522,
	"./instagram.png": 2673,
	"./linkedin.png": 6583,
	"./medium.png": 7932,
	"./menu.png": 2736,
	"./onlyfans.png": 141,
	"./paytm.png": 4186,
	"./pdf.png": 5231,
	"./phone-pe.png": 9549,
	"./phone.png": 5465,
	"./pinterest.png": 1123,
	"./skype.png": 2531,
	"./snapchat.png": 5367,
	"./soundcloud.png": 6129,
	"./spotify.png": 7219,
	"./telegram.png": 8160,
	"./tripadvisor.png": 5442,
	"./twitch.png": 9212,
	"./twitter.png": 4144,
	"./upi.png": 5497,
	"./video.png": 6452,
	"./website.png": 4322,
	"./whatsapp.png": 7711,
	"./youtube.png": 5050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8573;